import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login';
import { RegistrationComponent } from './components/registration/registration';
import { VerifyEmailComponent } from './components/verify-email/verify-email';
import { FileManagementComponent } from './components/file-management/file-management';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password';
import { ResetPasswordComponent } from './components/reset-password/reset-password';
import { DashboardComponent } from './components/dashboard/dashboard';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { InboxComponent } from './components/requests/inbox/inbox.component';
import { SentComponent } from './components/requests/sent/sent.component';
import { CompletedComponent } from './components/requests/completed/completed.component';
import { MySentComponent } from './components/requests/my-sent/my-sent.component';
import { DraftRequestListComponent } from './components/requests/draft-requests/draft-requests.component';
import { TaskViewerPageComponent } from './components/requests/task-viewer-page/task-viewer-page.component';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegistrationComponent },
  // Keep both routes but use a single consolidated component
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'file-management', component: FileManagementComponent, canActivate: [AuthGuard] },
  { path: 'request/:documentTypeId', component: DynamicFormComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  // Request Management Routes
  {
    path: 'requests',
    canActivate: [AuthGuard],
    children: [
      { path: 'inbox', component: InboxComponent },
      { path: 'sent', component: SentComponent },
      { path: 'completed', component: CompletedComponent },
      { path: 'my-sent', component: MySentComponent },
      { path: 'drafts', component: DraftRequestListComponent },
      { path: 'task-view/:pageType/:requestId/:taskId', component: TaskViewerPageComponent },
      { path: '', redirectTo: 'inbox', pathMatch: 'full' }
    ]
  }
];
